import { useCallback, useMemo, useState } from 'react';
import { TableRow } from '../Table/types';
import { ToggleColumn } from '../ToggleColumn';
import { UpdateLasHourRateEndDateModal } from '../';
import { useGetCurrentUser } from '@/modules/Users/queries';

type SelectedUserData<T> = {
  checked: boolean;
  row: T;
};

export const UserStatusColumn = <T extends TableRow>({
  onChange,
  value,
  row,
  userId,
}: {
  onChange: (checked: boolean, row: T) => void;
  value: boolean;
  row: T;
  userId: number;
}) => {
  const [isOpenEndDateModal, setIsOpenEndDateModal] = useState(false);
  const [selectedData, setSelectedData] =
    useState<SelectedUserData<T> | null>();

  const handleEndDateModalState = useCallback(() => {
    setIsOpenEndDateModal((prevIsOpen) => !prevIsOpen);
  }, []);

  const { data: currentUser } = useGetCurrentUser();

  const isOwnUser = useMemo(
    () => userId === currentUser?.id,
    [userId, currentUser?.id],
  );

  const handleStatusChange = useCallback(
    (checked: boolean, row: T) => {
      if (checked) {
        onChange(checked, row);
        return;
      }

      setSelectedData({ checked, row });
      setIsOpenEndDateModal(true);
    },
    [onChange],
  );

  const handleAfterEndDateSubmit = useCallback(() => {
    if (!selectedData) {
      return;
    }

    setIsOpenEndDateModal(false);
    onChange(selectedData.checked, selectedData.row);
  }, [onChange, selectedData]);

  return (
    <>
      <ToggleColumn
        disabled={isOwnUser}
        onChange={handleStatusChange}
        row={row}
        value={value}
      />
      {isOpenEndDateModal && (
        <UpdateLasHourRateEndDateModal
          userId={userId}
          isOpen={isOpenEndDateModal}
          handleClose={handleEndDateModalState}
          handleAfterSubmit={handleAfterEndDateSubmit}
        />
      )}
    </>
  );
};
